import { render, staticRenderFns } from "./SelectStockLimit.vue?vue&type=template&id=5ff177de&"
import script from "./SelectStockLimit.vue?vue&type=script&lang=js&"
export * from "./SelectStockLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff177de')) {
      api.createRecord('5ff177de', component.options)
    } else {
      api.reload('5ff177de', component.options)
    }
    module.hot.accept("./SelectStockLimit.vue?vue&type=template&id=5ff177de&", function () {
      api.rerender('5ff177de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SelectStockLimit.vue"
export default component.exports